import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {
    Alpine.data("searchForm", (items) => ({
        searchValue: "",
        suggestionsList: [],
        resultsList: [],
        resultsCount: 0,
        resultsCountText: "",
        resultsState: false,
        suggestions: [],
        isOpen: false,
        suggestionUri: "",
        searchUri: "",
        showAllItems: false,
        filterActive: false,
        isLoading: false,
        filtersAll: [],
        footerElement: null,

        initFilter(element) {
            this.filterSchema = JSON.parse(element.getAttribute("data-schema"));
            this.filterTags = JSON.parse(element.getAttribute("data-tags"));
            this.filtersAll = Object.values(document.querySelectorAll("[data-filter-id]")).map((item) => {
                return item.getAttribute("data-filter-id");
            });
            this.resetFilter();
            this.$watch("filterObj", (value) => {
                this.filterActive = Object.entries(value).some(([key, value]) => this.emptyFilter(key, value));
                if (this.searchValue) {
                    this.resultsState = false;
                    this.getSearchResults(this.searchValue);
                }
            });
            this.footerElement = document.querySelector("footer.m-footer");
        },

        updateItemsVisible() {
            if (!this.itemsElementList) {
                return;
            }

            this.$nextTick(() => {
                this.itemsVisible = Array.from(this.itemsElementList).filter((element) => {
                    return element.offsetParent !== null;
                }).length;
            });
        },

        toggleShowAll() {
            this.showAllItems = true;
        },

        filterLabel(category) {
            if (this.filterSchema[category] === "single") {
                return this.filterObj[category] === "all"
                    ? this.filterTags[category].label
                    : this.filterTags[category].tags[this.filterObj[category]];
            } else {
                return this.filterObj[category].length > 0
                    ? this.filterTags[category].label + " (" + this.filterObj[category].length + ")"
                    : this.filterTags[category].label;
            }
        },

        fullFilterLabel() {
            return Object.entries(this.filterObj)
                .map(([key, value]) => {
                    return this.emptyFilter(key, value) ? this.filterLabel(key) : "";
                })
                .filter((entry) => entry !== "")
                .join(", ");
        },

        emptyFilter(key, value) {
            return this.filterSchema[key] === "single" ? value !== "all" : value.length !== 0;
        },

        resetFilter() {
            this.filterObj = Object.fromEntries(
                Object.entries(this.filterSchema).map(([key, value]) => {
                    return [key, value === "single" ? "all" : []];
                })
            );
            this.filtersAll.forEach((item) => {
                let el = document.querySelectorAll("[data-filter-id=" + item + "]");
                el.forEach((item) => {
                    item.classList.remove("hidden");
                });
            });
            this.unhideFilterDetailElement();
        },

        hideFilterDetailElement() {
            document.querySelectorAll("details:not(.open-filters-mobile)").forEach((item) => {
                const items = item.querySelectorAll("li[data-filter-id]").length;
                const hiddenItems = item.querySelectorAll("li[data-filter-id].hidden").length;
                if (hiddenItems == items) {
                    item.classList.add("hidden");
                }
            });
        },

        unhideFilterDetailElement() {
            document.querySelectorAll("details:not(.open-filters-mobile)").forEach((item) => {
                item.classList.remove("hidden");
            });
        },

        init() {
            this.isLoading = false;
            this.resultsList = items;
            this.$refs.searchInput.value = "";
            this.suggestionUri = this.$refs.searchform.dataset.suggest;
            this.searchUri = this.$refs.searchform.dataset.search;
            this.resultsState = false;
            this.isOpen = false;
            window.addEventListener("scroll", () => {
                this.loadMore();
            });
        },

        returnDelay(value) {
            return "--delay:" + value / 10 + (value > 9 ? "s" : "0s");
        },

        loadMore() {
            const scrollHeight = document.documentElement.scrollHeight;
            const scrollTop = document.documentElement.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            const loadMore = this.$refs.loadMore;
            if (!loadMore) return;

            var deviceDistance = window.innerWidth > 300 && window.innerWidth < 768 ? 300 : 5;
            if (scrollTop + clientHeight > scrollHeight - deviceDistance) {
                if (this.$refs.loadMore.dataset.page != 0) {
                    this.resultsState = true;
                    this.getSearchResults(this.searchValue, this.$refs.loadMore.dataset.page);
                }
            }
        },

        searchReset() {
            this.resultsState = false;
            this.resultsList = [];
            this.resetFilter();
        },

        input: {
            ["@input.debounce"](event) {
                this.searchValue = event.target.value;

                const url = new URL(this.suggestionUri);
                const search_params = url.searchParams;

                search_params.set("term", this.searchValue);
                url.search = search_params.toString();

                fetch(url.toString())
                    .then((response) => {
                        return response.json();
                    })
                    .then((data) => {
                        if (data && "completions" in data) {
                            this.suggestionsList = data.suggestions;
                            this.getSuggestions(this.searchValue);
                            this.isOpen = true;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

            ["@focus"]() {
                this.isOpen = true;
            },

            ["@click.away"]() {
                this.isOpen = false;
            },

            ["@keyup.enter"]() {
                this.isOpen = false;
                this.filterActive = false;

                if (this.$refs.searchInput.value.length == 0) return;

                this.searchValue = this.$refs.searchInput.value;
                this.resultsState = false;
                this.getSearchResults(this.searchValue);
            },
        },

        hintsList: {
            ["@click"](event) {
                this.suggestions = [];
                this.cursorIndex = -1;
                this.isOpen = false;
            },
        },

        getSuggestions(searchTerm) {
            this.suggestions = [];
            const reg = searchTerm.replace(/\\/g, "");
            const re = new RegExp(reg, "gi");

            this.suggestionsList.map((el) => {
                el.title = el.title.replace(re, `<span>$&</span>`);
                this.suggestions.push(el);
            });
        },

        getSearchResults(searchTerm, page) {
            let currentPage = page ? page : 1;
            this.$refs.searchInput.blur();
            this.isOpen = false;
            this.isLoading = true;

            const url = new URL(this.searchUri);
            const search_params = url.searchParams;

            search_params.set("q", searchTerm);
            search_params.set("page", currentPage);

            if (this.filterActive) {
                Object.entries(this.filterObj).forEach(([key, value]) => {
                    if (value !== "all") {
                        search_params.set(key, value);
                    }
                });
            }

            url.search = search_params.toString();

            fetch(url.toString())
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (currentPage === 1) {
                        this.unhideFilterDetailElement();
                        this.resultsList = data.results;
                        this.filtersAll.forEach((item) => {
                            let el = document.querySelectorAll("[data-filter-id=" + item + "]");
                            if (!data.filters.includes(item.toString())) {
                                el.forEach((item) => {
                                    item.classList.add("hidden");
                                });
                            } else {
                                el.forEach((item) => {
                                    item.classList.remove("hidden");
                                });
                            }
                        });
                        this.hideFilterDetailElement();
                    } else {
                        this.resultsList = data.results.length > 0 ? [...this.resultsList, ...data.results] : [];
                    }
                    this.resultsCount = data.total;
                    let resultsCountText = this.$refs.resultsCountText.dataset.resulttext;
                    this.$refs.resultsCountText.innerHTML = resultsCountText.replace(
                        "$s1",
                        this.$refs.searchInput.value
                    );
                    this.resultsState = true;
                    this.$refs.loadMore.dataset.page = ++currentPage > data.maxPage ? 0 : currentPage;
                    this.isOpen = false;
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.log(error);
                });
        },

        setFooterHeight() {
            if (window.innerWidth < 768) {
                this.footerElement.classList.remove("fixed");
                this.footerElement.classList.remove("left-0");
                this.footerElement.classList.remove("bottom-0");
                this.footerElement.classList.remove("w-full");
                document.body.style.paddingBottom = "0";
            } else {
                this.footerElement.classList.add("fixed");
                this.footerElement.classList.add("left-0");
                this.footerElement.classList.add("bottom-0");
                this.footerElement.classList.add("w-full");
                document.body.style.paddingBottom = this.footerElement.offsetHeight + "px";
            }
        },
    }));
});
